/* BDEF-CUSTOM - Bicos de Fío (bicosdefio.com) / Prestige 11.4.1
   Barra de envío gratuito con progreso + carga bajo demanda del motor de recomendaciones del carrito.
   El motor vive en bdef-cart-recs.js. */

/* ============================================================
   CARRITO COMPARTIDO
   Una sola petición a /cart.js para la barra y las recomendaciones cuando se disparan juntas
   (apertura del drawer, refresco tras añadir). La promesa se reutiliza 1,5 s y se invalida en cada cambio.
   ============================================================ */
var bdefCartPromise = null;
var bdefCartPromiseTime = 0;

window.bdefGetCart = function() {
  var now = Date.now();
  if (!bdefCartPromise || now - bdefCartPromiseTime > 1500) {
    bdefCartPromiseTime = now;
    bdefCartPromise = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .catch(function(e) { bdefCartPromise = null; throw e; });
  }
  return bdefCartPromise;
};

window.bdefInvalidateCart = function() { bdefCartPromise = null; };

/* ============================================================
   FREE SHIPPING BAR
   ============================================================ */

async function bdefInitShippingBar() {
  var bar = document.querySelector('free-shipping-bar');
  if (!bar) return;

  if (!bar.querySelector('.bdef-bar__track')) {
    var track = document.createElement('div');
    track.className = 'bdef-bar__track';
    var fill = document.createElement('div');
    fill.className = 'bdef-bar__fill';
    track.appendChild(fill);
    bar.appendChild(track);
    new MutationObserver(function() { bdefRenderBar(bar); })
      .observe(bar, { attributes: true, attributeFilter: ['total-price'] });
    var span = bar.querySelector('span');
    if (span) {
      new MutationObserver(function() { bdefStyleShippingText(span); })
        .observe(span, { childList: true, subtree: true, characterData: true });
      bdefStyleShippingText(span);
    }
  }

  var rawPrice = bar.getAttribute('total-price');
  if (!rawPrice || rawPrice === 'NaN' || rawPrice === 'null') {
    try {
      var cart = await window.bdefGetCart();
      var total = cart.items
        .filter(function(i) { return i.requires_shipping; })
        .reduce(function(s, i) { return s + i.final_line_price; }, 0);
      var disc = (cart.cart_level_discount_applications || [])
        .reduce(function(s, d) { return s + d.total_allocated_amount; }, 0);
      bar.setAttribute('total-price', String(total - disc));
    } catch(e) {
      bar.setAttribute('total-price', '0');
    }
  }
  bdefRenderBar(bar);
}

function bdefRenderBar(bar) {
  var threshold  = parseFloat(bar.getAttribute('threshold'));
  var totalPrice = parseFloat(bar.getAttribute('total-price')) || 0;
  if (!threshold) return;
  var fill = bar.querySelector('.bdef-bar__fill');
  if (!fill) return;
  var pct = Math.min((totalPrice / threshold) * 100, 100);
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      fill.style.width = pct + '%';
      fill.style.backgroundColor = bdefBarColor(pct);
      bar.classList.toggle('bdef-bar--reached', totalPrice >= threshold);
      var span = bar.querySelector('span');
      if (span) bdefStyleShippingText(span);
    });
  });
}

/* Resalta importe y ENVIO GRATIS/GRATUITO en el texto del componente nativo.
   USA textContent (no innerHTML) para evitar el bug de &nbsp; que rompe el regex. */
function bdefStyleShippingText(span) {
  if (!span) return;
  if (span.querySelector('.bdef-bar__hl')) return;
  var text = span.textContent;
  if (!text.trim()) return;
  var html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  html = html.replace(/(\d[\d.,\u00a0\u202f ]*\u20ac)/g,
    '<strong class="bdef-bar__hl">$1</strong>');
  html = html.replace(/(env[\u00edi]o\s+grat(?:is|uito))/gi, function(match) {
    return '<strong class="bdef-bar__hl">' + match.toUpperCase() + '</strong>';
  });
  span.innerHTML = html;
}

/* Color gradual: 0% rojo -> 50% ambar -> 100% verde */
function bdefBarColor(pct) {
  var r, g, b, t;
  if (pct <= 50) {
    t = pct / 50;
    r = Math.round(224 + (232 - 224) * t);
    g = Math.round(82  + (193 - 82)  * t);
    b = Math.round(82  + (61  - 82)  * t);
  } else {
    t = (pct - 50) / 50;
    r = Math.round(232 + (82  - 232) * t);
    g = Math.round(193 + (184 - 193) * t);
    b = Math.round(61  + (136 - 61)  * t);
  }
  return 'rgb(' + r + ',' + g + ',' + b + ')';
}


/* ============================================================
   CARGA BAJO DEMANDA DEL MOTOR DE RECOMENDACIONES
   ============================================================ */
var bdefRecsScriptPromise = null;

function bdefEnsureRecsEngine() {
  if (window.bdefLoadRecommendations) return Promise.resolve();
  if (!bdefRecsScriptPromise) {
    bdefRecsScriptPromise = new Promise(function(resolve, reject) {
      var url = window.bdefConfig && window.bdefConfig.cartRecsUrl;
      if (!url) { reject(new Error('bdefConfig.cartRecsUrl no definido')); return; }
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function() { resolve(); };
      s.onerror = function() { bdefRecsScriptPromise = null; reject(new Error('No se pudo cargar bdef-cart-recs.js')); };
      document.head.appendChild(s);
    });
  }
  return bdefRecsScriptPromise;
}

function bdefRecs() {
  if (!document.getElementById('bdef-cart-recs')) return;
  bdefEnsureRecsEngine()
    .then(function() { window.bdefLoadRecommendations(); })
    .catch(function(e) { console.warn('BDEF recs:', e); });
}

function bdefOnCartUpdated() {
  window.bdefInvalidateCart();
  bdefInitShippingBar();
  bdefRecs();
}

/* Delegado en document: sigue funcionando aunque Prestige sustituya el contenido del drawer. */
document.addEventListener('dialog:after-show', function(event) {
  if (!event.target || event.target.tagName !== 'CART-DRAWER') return;
  bdefInitShippingBar();
  bdefRecs();
}, true);

/* cart-drawer:refreshed: cambios de carrito (añadir, eliminar, cantidad) */
document.addEventListener('cart-drawer:refreshed', bdefOnCartUpdated);


/* ============================================================
   BÚSQUEDA DESDE LA PÁGINA /search
   El cuadro de la página de resultados (sin resultados o sin término) es un formulario nativo
   que haría una búsqueda de Shopify sin la lógica del buscador. Al enviarlo se abre el buscador
   de la cabecera con el término escrito: mapa de términos, corrección de erratas, chips, atajos
   y destinos con filtros de la fase 2 (assets/bdef-predictive-search.js).
   ============================================================ */
function bdefInitSearchPageForms() {
  var forms = document.querySelectorAll('form.main-search-form');
  if (!forms.length) return;

  var headerSearch = document.querySelector('header-search');
  var headerInput = headerSearch && headerSearch.querySelector('input[name="q"]');
  if (!headerSearch || !headerInput || typeof headerSearch.show !== 'function') return;

  forms.forEach(function(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    form.addEventListener('submit', function(event) {
      var term = input.value.trim();
      if (!term) return;
      event.preventDefault();

      if (typeof window.clarity === 'function') {
        window.clarity('event', 'search_page_retry');
        window.clarity('set', 'search_retry_term', term.slice(0, 100));
      }

      Promise.resolve(headerSearch.show()).catch(function() {}).then(function() {
        headerInput.value = term;
        headerInput.focus();
        headerInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bdefInitSearchPageForms);
} else {
  bdefInitSearchPageForms();
}

/* ============================================================
   DESCUBRIR (sections/bdef-discovery.liquid)
   Pestañas Mujer / Hombre y medición de clics en Microsoft Clarity.
   ============================================================ */
function bdefInitDiscovery() {
  document.querySelectorAll('[data-bdef-discovery]').forEach(function(root) {
    var origin = root.getAttribute('data-bdef-discovery');

    root.querySelectorAll('[data-discovery-tab]').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var key = tab.getAttribute('data-discovery-tab');
        root.querySelectorAll('[data-discovery-tab]').forEach(function(t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-discovery-panel]').forEach(function(panel) {
          panel.hidden = panel.getAttribute('data-discovery-panel') !== key;
        });
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'discovery_tab');
          window.clarity('set', 'discovery_tab', key);
        }
      });
    });

    root.addEventListener('click', function(event) {
      if (typeof window.clarity !== 'function') return;
      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      var type = link.getAttribute('data-discovery-type') || (link.closest('.product-card') ? 'producto' : 'otro');
      window.clarity('event', 'discovery_click');
      window.clarity('set', 'discovery_origin', origin);
      window.clarity('set', 'discovery_type', type);
      window.clarity('set', 'discovery_label', (link.textContent || '').trim().slice(0, 100));
    });

    if (typeof window.clarity === 'function') {
      window.clarity('set', 'discovery_view', origin);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bdefInitDiscovery);
} else {
  bdefInitDiscovery();
}

/* ============================================================
   IFRAMES DIFERIDOS (widget de valoraciones de TrustProfile)
   El iframe pesa ~950 KB (lleva su propia fuente incrustada). En las plantillas lleva
   data-bdef-src en lugar de src, y aquí se carga solo cuando está a 300 px de la pantalla.
   ============================================================ */
function bdefInitLazyIframes() {
  var frames = document.querySelectorAll('iframe[data-bdef-src]');
  if (!frames.length) return;

  var load = function(frame) {
    if (!frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-bdef-src'));
  };

  if (!('IntersectionObserver' in window)) {
    frames.forEach(load);
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        load(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '300px 0px' });

  frames.forEach(function(frame) { observer.observe(frame); });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bdefInitLazyIframes);
} else {
  bdefInitLazyIframes();
}